import React, { memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col, Button } from 'antd'
import { useHistory } from 'react-router-dom'

import classes from './styles.module.scss'
import { StoreValue } from 'store'

interface ISuccessfullyOperation {
	text: string
}

const SuccessfullyOperation: React.FunctionComponent<ISuccessfullyOperation> = ({
	text,
}) => {
	const { i18n } = useTranslation()
	const t = i18n.getFixedT('ro')
	const history = useHistory()

	const goToHomePage = useCallback(() => {
		history.push(`/${i18n.language}`)
	}, [history, i18n.language])

	return (
		<div className={classes.container}>
			<Row className={classes.infoText} gutter={8}>
				<Col sm={{ span: 24 }}>{text}</Col>
			</Row>
			<Row>
				<Col sm={{ span: 24 }}>
					<div className={classes.saveButton}>
						<Button type="primary" onClick={goToHomePage}>
							{t('Go to home page')}
						</Button>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default memo((props: ISuccessfullyOperation) => (
	<StoreValue keys={['user|storeUser']}>
		<SuccessfullyOperation {...props} />
	</StoreValue>
))
